export default [
    // require('@/assets/images/pc/body.jpg'),
    // require('@/assets/images/utils/bg-modal-invite_apply.png'),
    // require('@/assets/images/pc/bg-team.png'),
    // require('@/assets/images/pc/main-title.png'),
    // require('@/assets/images/m/bg-modal-rule.png'),
    // require('@/assets/images/m/modal-bind.png'),
    // require('@/assets/images/m/modal-comfirm.png'),
    // require('@/assets/images/m/modal-task.png'),
    // require('@/assets/images/m/modal-ticket.png'),
];


// WEBPACK FOOTER //
// ./src/assets/js/imgPreloaderList.js